(ns frontend.test.survey.timeseries-test
  (:require [frontend.test.survey.sub :as sub]
            [re-frame.core :as rf]
            [ui.view.survey.view :as survey-view]))

(defn timeseries-survey-test
  []
  (let [configuration @(rf/subscribe [::sub/survey-configuration])]
    [:div
     [:label "Timeseries survey test"]
     [survey-view/view configuration false]

     ]))
